import each from 'lodash-es/each';
import capitalize from './capitalize';

export default function isAvailableAuthorization(credentials, prefix) {
    let available = false;
    each(credentials, (credential) => {
        if (credential[`is${capitalize(prefix)}Available`] === true) {
            available = true;
        }
    });

    return available;
}
